import axios, {
  AxiosError,
  // AxiosInstance,
  InternalAxiosRequestConfig,
  // AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { LOCAL_STORAGE_AUTH_TOKEN } from 'common/localStorageKeys';
import ROUTE_PATHS from 'routes/values';
import { clearSession } from 'helpers';
import { API_URL, SHOW_LOGS } from '../config';
import { PREFIX_AUTHORIZATION_TOKEN } from './values';

const apiConfigDefault = {
  baseURL: `${API_URL.base}/${API_URL.name}/${API_URL.versions.V3}`,
  timeout: API_URL.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
};

const ApiInstance = axios.create(apiConfigDefault);

// ApiInstance.interceptors.request.use(
//   (req) => {
//     req.headers.Authorization = `Bearer XXXXXXXXXXX`;
//     req.headers.time = { startTime: new Date() };
//     req.headers.myAuti = 'myAuti';
//     return req;
//   },
//   (err) => Promise.reject(err),
// );

// // eslint-disable-next-line no-console
// ApiInstance.interceptors.response.use(
//   (res) => {
//     res.data.time = new Date();
//     return res;
//   },
//   (error) => {
//     const status = error.response ? error.response.status : null;

//     switch (status) {
//       case 401: {
//         // Handle unauthorized access
//         console.error('UNAUTHORIZED', error);
//         break;
//       }
//       case 422:
//         console.error('UNPROCESSABLE_ENTITY', error);
//         break;
//       case 500:
//         console.error('SERVER_ERROR', error);
//         break;
//       case 404:
//         console.error('FOUND_ERRORS', error);
//         break;
//       default:
//         console.error('interceptors ERROR::', error);
//     }
//     return Promise.reject(error);
//   },
// );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (SHOW_LOGS) {
    console.info(`[request] [${JSON.stringify(config)}]`);
  }
  if (config.headers.apiVersion) {
    // eslint-disable-next-line no-param-reassign
    config.baseURL = `${API_URL.base}/${API_URL.name}/${config.headers.apiVersion}`;
  }

  const authToken =
    config.headers.Authorization === null || config.headers.Authorization
      ? config.headers.Authorization
      : `${PREFIX_AUTHORIZATION_TOKEN}${window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN)}`;

  config.headers.set('Authorization', authToken);
  // config.headers.set('time', new Date().toDateString());
  // config.headers.set('myAuti', 'myAuti');

  return config;

  // return {
  //   ...config,
  //   headers: {
  //     ...(config.headers || {}),
  //     Authorization: `Bearer XXXXXXXXXXX`,
  //     time: new Date().toDateString(),
  //     myAuti: 'myAuti',
  //   },
  // };
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => Promise.reject(error);

const onResponse = (response: AxiosResponse): AxiosResponse => response;

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  const status = error.response ? error.response.status : null;

  const { config } = error || {};
  const { headers } = config || {};

  if (headers?.isFatal) {
    if (SHOW_LOGS) {
      console.error('isFaltaERROR', error);
    }
  }

  switch (status) {
    case 401: {
      // Handle unauthorized access
      if (SHOW_LOGS) {
        console.error('UNAUTHORIZED', error);
      }

      if (headers?.isFatal) {
        clearSession();
        window.location.href = ROUTE_PATHS.SIGN_UP;
      }

      break;
    }
    case 422:
      console.error('UNPROCESSABLE_ENTITY', error);
      break;
    case 500:
      console.error('SERVER_ERROR', error);
      break;
    case 404:
      console.error('FOUND_ERRORS', error);
      break;
    default:
      console.error('interceptors ERROR::', error);
  }

  return Promise.reject(error);
};

const setAuthToken = (token: string): void => {
  if (token) {
    ApiInstance.defaults.headers.common.Authorization = `Token token=${token}`;
  }
};

ApiInstance.interceptors.request.use(onRequest, onRequestError);

ApiInstance.interceptors.response.use(onResponse, onResponseError);

export default ApiInstance;
export { apiConfigDefault, setAuthToken };
